import { bindActionCreators } from 'redux';
import idx from 'idx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toggleVoting } from 'focus_groups/ducks/vote';

import VoteModal from 'focus_groups/components/voting_modal';

export function mapStateToProps(state) {
  const isVoting = idx(state, _ => _.project.focusGroups.vote.isVoting);
  return { isVoting };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggle: toggleVoting,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VoteModal));



// WEBPACK FOOTER //
// ./focus_groups/containers/voting_modal.js